import { useNotification } from 'hooks/ui/useNotification';
import api from 'lib/trpcClient';

function useGetAdvisedApplicationUrl() {
  const notification = useNotification();
  const utils = api.useUtils();

  return {
    mutate: async (id: string) => {
      try {
        const result = await utils.incompleteInvestment.getInvitationUrl.fetch({
          id,
        });
        if (result.url) {
          navigator.clipboard.writeText(result.url);
          notification.success('Application URL copied to clipboard.');
        } else {
          notification.error('Application URL not available.');
        }
      } catch {
        notification.error('Failed to get application URL.');
      }
    },
    isPending: false,
  };
}

export default useGetAdvisedApplicationUrl;
